module.exports = fox._r("images/h1360i.jpg", __webpack_public_path__ + "images/h1360i.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/h1360i.jpg
// module id = 1052
// module chunks = 4